var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.showShortCutMenu && _vm.shortcutMenuContent && !_vm.isLiveChatStarted)?_c('div',[_c('div',{staticClass:"shortcut-menu-button",class:{shortcut_menu_open:_vm.displayShortcutPanel},domProps:{"innerHTML":_vm._s(_vm.getHamburgerMenuSVGString())},on:{"click":function($event){return _vm.onShortcutPanelMenuButtonClicked()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }